import { httpClient } from '@/modules/common/services/http/http-client';
import { TotalBalanceResponse } from './types';

const httpConsolidation = httpClient.withOptions({
  baseURL: `${process.env.VUE_APP_BFF_URL}/consolidation`
});

export function getTotalBalance(): Promise<TotalBalanceResponse> {
  return httpConsolidation.get('/v1/balance/total');
}
